module.exports = __webpack_public_path__ + "static/media/change-thumbnail.3a96eed4.gif";